<mat-form-field class="example-chip-list">
  <mat-label>{{ label() }}</mat-label>

  <mat-chip-grid #chipGrid>
    @for (option of selectedItems(); track $index) {
    <mat-chip-row (removed)="remove(option.value)">
      {{ option.title }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    }
  </mat-chip-grid>

  <input
    #inputEl
    [matChipInputFor]="chipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [placeholder]="placeholder()"
    [(ngModel)]="inputValue"
  />
</mat-form-field>

<div class="options-wrapper">
  <div class="options" appScrollEnd (reachedEnd)="loadNext.emit()">
    <div class="options-list">
      @for (option of filteredOptions(); track option) {
      <div class="options-item" (click)="selectOption(option)">
        {{ option.title }}
      </div>
      }
    </div>
  </div>
</div>
